import cart from "../../services/routes/cart";
import { sumBy, sum, find, get } from "lodash";

const state = {
    items: [],
    coupon: null,
};

const getters = {
    items: (state) => state.items,
    item: (state) => (id) => state.items.find((item) => item.id == id),
    itemByStockLineId: (state) => (id) =>
        !state.items
            ? false
            : state.items.find((item) => item.stock_line_id == id),
    coupon: (state) => state.coupon,
    totalItems: (state) => _.sumBy(state.items, "qty"),
    totalPointsEarned: (state) =>
        totaller(state.items, "extras.loyalty.points"),
    totalPrice: (state) => totaller(state.items, "price"),
    totalPointsCost: (state) =>
        totaller(state.items, "extras.loyalty_cost.points"),
    netPrice: (state) =>
        !state.items
            ? 0
            : _.sum(state.items.map((item) => item.price * item.qty)),
    totalCouponDecrease: (state) => {
        if (!isNaN(state.coupon.amount)) {
            return state.coupon.amount;
        }
        return 0.0;
    },

    /**
     * Too many magic strings here. Need definitions of what a physical item is etc.
     * @param state
     * @returns {boolean}
     */
    containsPhysicalItems: (state) => {
        return !!_.find(state.items, function (item) {
            return item.type === "dvd" || item.type === "cd";
        });
    },
    onlyContainsPhysicalItems: (state) => {
        return state.items.every(
            (item) => item.extras.type === "dvd" || item.extras.type === "cd"
        );
    },
    containsDigitalItems: (state) => {
        return !!_.find(state.items, function (item) {
            return item.type !== "dvd" || item.type !== "cd";
        });
    },
    canDeliverWithoutAddress: (state) => {
        return state.items.every(
            (item) => item.type !== "dvd" && item.type !== "cd"
        );
    },
};
const actions = {
    hydrate({ commit }) {
        return new Promise((resolve, reject) => {
            cart.get()
                .then((response) => {
                    commit("hydrateItems", response.data.items || {});
                    commit("hydrateCoupon", response.data.coupon);

                    let stock_ids = response.data.items.map(
                        (item) => item.extras.stock_id
                    );

                    resolve();
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    },
    updateItemExtras({ commit, dispatch }, { item, key, value }) {
        item.extras[key] = value;
        commit("updateItem", item);
        dispatch("persistCart");
    },
    updateItem({ commit, dispatch }, { item, key, value }) {
        let newItem = { ...item, [key]: value };

        if (key === "qty" && value === 0) {
            commit("removeItem", newItem);
        } else {
            commit("updateItem", newItem);
        }

        dispatch("persistCart");
    },
    calcPricing({ commit }) {
        commit("calcPricing");
    },
    persistCart({ getters, dispatch }) {
        return cart
            .persist(getters.items)
            .then(() => {
                toast({
                    type: "success",
                    title: "Cart updated successfully",
                });

                dispatch("calcPricing");

                return handlePersistence(getters);
            })
            .catch((error) => {
                toast({
                    type: "error",
                    title: "There was an error updating your cart",
                });
            });
    },
    removeItem({ commit, dispatch }, item) {
        return new Promise((resolve, reject) => {
            commit("removeItem", item);
            dispatch("persistCart").then(() => {
                resolve();
            });
        });
    },
    addItem({ commit, dispatch }, data) {
        return new Promise((resolve, reject) => {
            cart.add(data)
                .then((response) => {
                    commit("hydrateItems", response.data.items);
                    // dispatch('persistCart'); // Removed due to duplicate items being added
                    toast({
                        type: "success",
                        title: "Cart updated successfully",
                    });
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                    toast({
                        type: "error",
                        title: error.response.data.message,
                    });
                });
        });
    },
    applyCoupon({ commit, dispatch }, code) {
        return new Promise((resolve, reject) => {
            cart.applyCoupon(code)
                .then((response) => {
                    dispatch("hydrate").then((response) => {
                        toast({ type: "success", title: "Coupon Applied" });
                        resolve();
                    });
                })
                .catch((error) => {
                    toast({
                        type: "error",
                        title: error.response.data.message,
                    });
                    reject();
                });
        });
    },
    removeCoupon({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            cart.removeCoupon()
                .then((response) => {
                    dispatch("hydrate").then((response) => {
                        toast({ type: "success", title: "Coupon Removed" });
                        resolve();
                    });
                })
                .catch((error) => {
                    toast({ type: "error", title: "Unexpected Error" });
                    reject();
                });
        });
    },
};

const mutations = {
    hydrateItems(state, items) {
        state.items = items;
    },
    hydrateCoupon(state, coupon) {
        state.coupon = coupon;
    },
    updateDefaultCount(state, count) {
        state.defaultCount = count;
    },
    updateItem(state, item) {
        let stateItem = state.items.find(
            (stateItem) => stateItem.id === item.id
        );
        Object.assign(stateItem, item);
    },
    removeItem(state, item) {
        state.items = [
            ...state.items.filter((stateItem) => stateItem.id !== item.id),
        ];
    },
    calcPricing(state) {
        state.items = state.items.filter((item) => item.id);
    },
};

const handlePersistence = _.debounce(function (getters) {
    cart.persist(getters.items)
        .then(() => {
            toast({
                type: "success",
                title: "Cart updated successfully",
            });
        })
        .catch((error) => {
            toast({
                type: "error",
                title: "There was an error updating your cart",
            });
        });
}, 450);

const totaller = (items = [], field) => {
    return items.reduce((total, item) => {
        return total + item.qty * _.get(item, field);
    }, 0);
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
